const META_PIXEL_ID = "1445113654400115";
const GOOGLE_TAG_ID = "AW-18496459014";
// Acción de conversión de Google Ads "Registro de Leads" (send_to oficial de la cuenta).
const GOOGLE_ADS_CONVERSION_LABEL = "AW-18496459014/umWqCO__jJgdEIai5vNE";

// Consent Mode v2: se llama al arrancar la app. Solo crea el stub de gtag y
// registra el estado por defecto DENEGADO. No carga ningún script ni envía datos.
export const initConsentDefaults = () => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== "function") {
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
  }
  window.gtag("consent", "default", {
    ad_storage: "denied",
    analytics_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    wait_for_update: 500,
  });
};

// Se llama si el usuario RECHAZA: deja constancia del denegado sin cargar scripts.
export const denyAnalytics = () => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      ad_storage: "denied",
      analytics_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
    });
  }
};

// Se llama SOLO si el usuario ACEPTA. Carga las etiquetas una única vez.
export const loadAnalytics = () => {
  if (typeof window === "undefined" || window.__analyticsLoaded) return;
  window.__analyticsLoaded = true;
  initConsentDefaults();

  /* Google Consent Mode v2: conceder tras aceptar */
  if (typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      ad_storage: "granted",
      analytics_storage: "granted",
      ad_user_data: "granted",
      ad_personalization: "granted",
    });
  }

  /* Google tag (gtag.js) — código oficial de Google */
  if (!document.querySelector(`script[src*="${GOOGLE_TAG_ID}"]`)) {
    const gtagScript = document.createElement("script");
    gtagScript.async = true;
    gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_TAG_ID}`;
    document.head.appendChild(gtagScript);
  }
  window.gtag("js", new Date());
  window.gtag("config", GOOGLE_TAG_ID);
  /* End Google tag */

  /* Meta Pixel Code — código oficial de Meta */
  if (typeof window.fbq !== "function") {
    // eslint-disable-next-line no-unused-expressions
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  }
  window.fbq("consent", "grant");
  window.fbq("init", META_PIXEL_ID);
  window.fbq("track", "PageView");

  const noscript = document.createElement("noscript");
  const img = document.createElement("img");
  img.height = 1;
  img.width = 1;
  img.style.display = "none";
  img.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`;
  noscript.appendChild(img);
  document.body.appendChild(noscript);
  /* End Meta Pixel Code */
};

// Conversión: envío del formulario de presupuesto
export const trackLeadConversion = (label) => {
  if (typeof window === "undefined") return;
  if (typeof window.fbq === "function") {
    window.fbq("track", "Lead");
  }
  if (typeof window.gtag === "function") {
    window.gtag("event", "generate_lead", {
      event_category: "presupuesto",
      event_label: label,
    });
    if (GOOGLE_ADS_CONVERSION_LABEL) {
      window.gtag("event", "conversion", {
        send_to: GOOGLE_ADS_CONVERSION_LABEL,
        value: 1.0,
        currency: "EUR",
      });
    }
  }
};

// Conversión: contacto directo (clic en teléfono o WhatsApp)
export const trackContact = (channel) => {
  if (typeof window === "undefined") return;
  if (typeof window.fbq === "function") {
    window.fbq("track", "Contact");
  }
  if (typeof window.gtag === "function") {
    window.gtag("event", "contact", {
      event_category: "contacto",
      event_label: channel,
    });
  }
};
